// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"1ef10c52ce60b794f2d6","418":"7d455c14136a702ddc7c","770":"2f861e25322ff0273839"}[chunkId] + ".chunk.js";
};